// @flow
import WeekMatchResult from 'components/match/WeekMatchResult';
import { connect } from 'react-redux';

import { fetchAllMatchesForMatchOfTheWeek, fetchMatchResult } from 'actions/matchResultActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/match/WeekMatchResult';

export default connect(
  (state: StateType): StateProps => ({
    allMatchesForMatchOfTheWeek: state.matchResultState.allMatchesForMatchOfTheWeek,
    ligue_id: state.settingsState.ligue_id,
    match_semaine: state.settingsState.match_semaine,
    result: state.matchResultState.result,
    status: state.matchResultState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchMatchResultOfTheWeek: (match_semaine: number) => dispatch(fetchMatchResult(match_semaine)),
    fetchAllMatchesForMatchOfTheWeek: (structure: number, dateMinusAWeek: string, datePlusAWeek: string) =>
      dispatch(fetchAllMatchesForMatchOfTheWeek(structure, dateMinusAWeek, datePlusAWeek))
  })
)(WeekMatchResult);
